<template>
  <section class="dp-layout">
    <section class="dp-left">
      <DepartmentPane directory-scope="teaching" @tree-node-click="treeNodeClick"></DepartmentPane>
    </section>

    <section class="dp-right">
      <!--工具条-->
      <toolbar :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

      <!--列表-->
      <div class="tbl-scroll-host">
      <el-table :data="users" v-loading="listLoading" @select="dialogCheck" @row-click="selectCurrentRow" ref="table"
        height="100%" style="width: 100%" class="custom-tbl center-table">
        <el-table-column prop="DeptName" label="部门" width></el-table-column>
        <el-table-column prop="Count" label="总人数" width></el-table-column>

        <!-- 统一提取所有时间段 -->
        <template v-for="(timePeriod, index) in getAllTimePeriods()">
          <!-- 时间段列 -->
          <el-table-column :label="timePeriod.Name" width="auto" :key="`time-period-${index}`">
            <!-- 低温列 -->
            <el-table-column :prop="`TimePeriods[${index}].LowTemperatureCount`" label="低温" width="60"
              :key="`low-temp-${index}`">
              <template slot-scope="scope">
                <span @click="handleColumnClick(scope.row.DeptId, 'LowTemperature', timePeriod.Id, scope.row.Date)"
                  style="cursor: pointer;">{{
                    scope.row.TimePeriods[index].LowTemperatureCount === 0 ? '' :
                      scope.row.TimePeriods[index].LowTemperatureCount }}</span>
              </template>
            </el-table-column>
            <!-- 正常列 -->
            <el-table-column :prop="`TimePeriods[${index}].NormalCount`" label="正常" width="60"
              :key="`normal-count-${index}`">
              <template slot-scope="scope">
                <span @click="handleColumnClick(scope.row.DeptId, 'Normal', timePeriod.Id, scope.row.Date)"
                  style="cursor: pointer;">{{
                    scope.row.TimePeriods[index].NormalCount === 0 ? '' : scope.row.TimePeriods[index].NormalCount
                  }}</span>
              </template></el-table-column>
            <!-- 低热列 -->
            <el-table-column :prop="`TimePeriods[${index}].LowHeatCount`" label="低热" width="60"
              :key="`low-heat-${index}`">
              <template slot-scope="scope">
                <span @click="handleColumnClick(scope.row.DeptId, 'LowHeat', timePeriod.Id, scope.row.Date)"
                  style="cursor: pointer;">{{
                    scope.row.TimePeriods[index].LowHeatCount === 0 ? '' : scope.row.TimePeriods[index].LowHeatCount
                  }}</span>
              </template></el-table-column>
            <!-- 高热列 -->
            <el-table-column :prop="`TimePeriods[${index}].HighHeatCount`" label="高热" width="60"
              :key="`high-heat-${index}`">
              <template slot-scope="scope">
                <span @click="handleColumnClick(scope.row.DeptId, 'HighHeat', timePeriod.Id, scope.row.Date)"
                  style="cursor: pointer;">{{
                    scope.row.TimePeriods[index].HighHeatCount === 0 ? '' : scope.row.TimePeriods[index].HighHeatCount
                  }}</span>
              </template></el-table-column>
            <!-- 未测温 -->
            <el-table-column :prop="`TimePeriods[${index}].NotMeasuredCount`" label="未测温" width="70"
              :key="`not-count-${index}`">
              <template slot-scope="scope">
                <span @click="handleColumnClick(scope.row.DeptId, 'NotMeasured', timePeriod.Id, scope.row.Date)"
                  style="cursor: pointer;">{{
                    scope.row.TimePeriods[index].NotMeasuredCount === 0 ? '' :
                      scope.row.TimePeriods[index].NotMeasuredCount }}</span>
              </template>
            </el-table-column>
          </el-table-column>
        </template>

        <!-- <el-table-column label="操作" width="80">
          <template slot-scope="scope">
            <el-button @click="showHistory(scope.row)" type="text">查看</el-button>
          </template>
        </el-table-column> -->

      </el-table>
      </div>

      <!--工具条-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleCurrentChange" :page-size="10" :total="total"
          style="float: right"></el-pagination>
      </el-col>

      <el-dialog title="测温记录" :visible.sync="dialogVisible" width="55%" center @close="historyDataHandleClose"
        destroy-on-close>

        <!-- 表格筛选  -->
        <div style="padding-left: 5px">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="全部" name=""></el-tab-pane>
            <el-tab-pane label="低温" name="LowTemperature"></el-tab-pane>
            <el-tab-pane label="正常" name="Normal"></el-tab-pane>
            <el-tab-pane label="低热" name="LowHeat"></el-tab-pane>
            <el-tab-pane label="高热" name="HighHeat"></el-tab-pane>
          </el-tabs>
        </div>

        <el-table :data="historyData" class="custom-tbl" style="width: 100%">
          <el-table-column property="UserName" label="姓名"></el-table-column>
          <el-table-column property="TemperatureValue" label="体温"></el-table-column>
          <el-table-column property="TemperatureVtime" label="采集时间"></el-table-column>
          <el-table-column property="TemperatureIntervalType" label="状态"></el-table-column>
          <el-table-column property="CreateTime" label="上报时间"></el-table-column>
        </el-table>

        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="handleHistoryDataChange" :page-size="10"
            :total="historyDataTotal" style="float: right"></el-pagination>
        </el-col>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

      <el-dialog title="未测温人员" :visible.sync="notMeasuredDialogVisible" width="40%" center destroy-on-close>
        <el-table :data="notMeasuredData" class="custom-tbl" style="width: 100%">
          <el-table-column property="StuName" label="姓名"></el-table-column>
          <el-table-column property="Status" label="状态">未测温</el-table-column>
        </el-table>
        <el-col :span="24" class="toolbar">
          <el-pagination layout="total, prev, pager, next, jumper" @current-change="notMeasuredDataChange" :page-size="10"
            :total="notMeasuredDataTotal" style="float: right"></el-pagination>
        </el-col>

        <div slot="footer" class="dialog-footer">
          <el-button @click="notMeasuredDialogVisible = false">取 消</el-button>
        </div>
      </el-dialog>

    </section>

  </section>
</template>

<script>
import util from "../../../util/date";
import { getTemperatureDeptDailyDetail, getTemperatureHistory, exportTemperatureDeptDailyDetail } from '../../api/modules/misc';
import { getNotMeasuredUserPage } from '../../api/modules/system';
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import DepartmentPane from '../../components/DepartmentPane'

export default {
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      activeName: '',
      filters: {
      },
      searchList: [
        {
          label: '日期',
          key: 'date',
          type: 'date'
        },
      ],
      buttonList: [],
      options: [],
      users: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      statusList: [
        { name: "激活", value: true },
        { name: "禁用", value: false },
      ],
      total: 0,
      page: 1,
      listLoading: false,
      sels: [], //列表选中列
      currentRow: null,
      isResouceShow: 0,
      DepartmentId: "",
      dialogVisible: false,
      currentDate: "",
      historyData: [],
      historyDataTitle: "",
      historyDataTotal: 0,
      historyDataPage: 1,
      historyUserId: 0,

      deptKqtData: [],
      deptKqtDataDialogVisible: false,
      deptKqtDate: "",
      deptKqtDataTotal: 0,
      deptKqtDataPage: 1,
      ruleId: "",
      notMeasuredDialogVisible: false,
      notMeasuredData: [],
      notMeasuredDataTotal: 0,
      notMeasuredDataPage: 1,
    };
  },
  computed: {
  },
  methods: {
    handleColumnClick(deptId, timePeriodName, timePeriodId, date) {
      this.historyUserId = deptId;
      this.ruleId = timePeriodId;
      this.activeName = timePeriodName;
      this.deptKqtDate = date;
      if (timePeriodName === "NotMeasured") {
        this.handleNotMeasuredDataQuery();
      } else {
        this.handleHistoryDataQuery();
      }
    },

    getAllTimePeriods() {
      // 假设所有用户的时间段是一致的，取第一个用户的时间段数据
      if (this.users.length > 0) {
        return this.users[0].TimePeriods;
      }
      return [];
    },
    getStatusColor(status) {
      if (status != "normal") {
        return 'red';
      }
      return '';
    },

    treeNodeClick(data, node, component) {
      this.DepartmentId = data.value
      this.handleQuery();
    },

    dialogCheck(selection, row) {
      this.currentRow = null;
      this.$refs.table.clearSelection();
      if (selection.length === 0) {
        return;
      }
      if (row) {
        this.selectCurrentRow(row);
      }
    },
    selectCurrentRow(val) {
      if (val) {
        this.currentRow = val;
        this.$refs.table.clearSelection();
        this.$refs.table.toggleRowSelection(val, true);
      }
    },
    callFunction(item) {
      this.currentDate = item.search.date || "";
      if (typeof item.search == 'object') {
        this.filters = item.search
      } else {
        this.filters = {
          key: item.search,
        }
      }
      this[item.Func].apply(this, item)
    },

    handleCurrentChange(val) {
      this.page = val;
      this.handleQuery();
    },
    //获取用户列表
    handleQuery() {
      let _this = this;
      let para = {
        page: this.page,
        departmentId: this.DepartmentId,
        ...this.filters,
      };
      this.listLoading = true;

      //NProgress.start();
      getTemperatureDeptDailyDetail(para).then((res) => {
        this.total = res.data.response.dataCount;
        this.users = res.data.response.data;
        this.listLoading = false;
      });
    },

    handleClick(tab, event) {
      this.handleHistoryDataQuery();
    },

    handleHistoryDataChange(val) {
      this.historyDataPage = val;
      this.handleHistoryDataQuery();
    },

    handleHistoryDataQuery() {
      let para = {
        page: this.historyDataPage,
        date: this.deptKqtDate,
        deptId: this.historyUserId,
        code: this.activeName,
        ruleId: this.ruleId
      };
      getTemperatureHistory(para).then((res) => {
        this.historyDataTotal = res.data.response.dataCount;
        this.historyData = res.data.response.data;
        this.$nextTick(() => { this.dialogVisible = true; })

      });
    },
    historyDataHandleClose() {
      this.historyData = [];
      this.historyDataTotal = 0;
      this.historyDataPage = 1;
    },

    notMeasuredDataChange(val) {
      this.notMeasuredDataPage = val;
      this.handleNotMeasuredDataQuery();
    },

    handleNotMeasuredDataQuery() {
      let para = {
        page: this.notMeasuredDataPage,
        date: this.deptKqtDate,
        deptId: this.historyUserId,
        ruleId: this.ruleId
      };
      getNotMeasuredUserPage(para).then((res) => {
        this.notMeasuredDataTotal = res.data.response.dataCount;
        this.notMeasuredData = res.data.response.data;
        this.$nextTick(() => { this.notMeasuredDialogVisible = true; })

      });
    },
    async exportExcel() {
      try {
        let para = {
          page: this.page,
          departmentId: this.DepartmentId,
          ...this.filters,
          type: this.activeName
        };

        var fileName = "体温日报表";
        const response = await exportTemperatureDeptDailyDetail(para);
        if (!response.data) {
          this.$message({
            message: "导出数据为空",
            type: "error",
          });
          return;
        }
        // 处理导出数据        
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName + '.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error('下载失败:', error);
      }
    },

  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style scoped>
.custom-tbl /deep/ .has-gutter .el-checkbox {
  display: none;
}

/* 添加垂直居中样式 */
.center-table /deep/ .el-table__header th,
.center-table /deep/ .el-table__body td {
  vertical-align: middle;
}

/* 添加水平居中样式 */
.center-table /deep/ .el-table__header th,
.center-table /deep/ .el-table__body td {
  text-align: center;
}
</style>
